import { testListConstants } from "../_redux-constants";
import { testListService } from "../../_services";

function getTestList(queryParams) {
  function getTestListLoad() {
    return { type: testListConstants.TEST_LIST_LOADING };
  }
  function testListSuccess(data) {
    return { type: testListConstants.TEST_LIST_SUCCESS, data };
  }
  function testListFailure(error) {
    return { type: testListConstants.TEST_LIST_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getTestListLoad());
    testListService.getTestList(queryParams).then(
      (data) => {
        dispatch(testListSuccess(data));
      },
      (error) => {
        dispatch(testListFailure(error?.toString()));
      }
    );
  };
}

export const testListActions = {
  getTestList,
};
